import {
  addMymePreviewImageAPI,
  createMymeAPI,
  deleteMymeModuleAPI,
  editMymeAPI,
  editMymeModulesAPI,
  GETSingleMyme,
  getSingleMymeAPI,
  GETTenantMymeCategories,
  getTenantMymeCategoriesAPI,
  PATCHEditMymeModulesReqBody,
  PATCHEditMymeModulesResponse,
  PATCHEditMymeReqBody,
  PATCHEditMymeResponse,
  POSTAddMymePreviewImageReqBody,
  POSTAddMymePreviewImageResponse,
  POSTCreateMymeReqBody,
  POSTCreateMymeResponse
} from '@myme/api';
import { sendRequest, UUID } from '@myme/utils';

const getMymeIdRecord = (mymeId: UUID) => ({
  key: 'mymeId',
  value: mymeId
});

/* **** POST **** /myme */
export const createMyme = async (reqBody: POSTCreateMymeReqBody) =>
  sendRequest<POSTCreateMymeResponse, POSTCreateMymeReqBody>(createMymeAPI, {
    reqBody
  });

/* **** POST **** /myme/:mymeId/preview-image */
export const addMymePreviewImage = async (mymeId: UUID, form: FormData) =>
  sendRequest<POSTAddMymePreviewImageResponse, POSTAddMymePreviewImageReqBody>(addMymePreviewImageAPI, {
    reqBody: form as unknown as POSTAddMymePreviewImageReqBody,
    args: [getMymeIdRecord(mymeId)]
  });

/* **** DELETE **** /myme/:mymeId/modules/:moduleId */
export const deleteMymeModule = async (mymeId: UUID, moduleId: UUID) =>
  sendRequest<PATCHEditMymeModulesResponse, PATCHEditMymeModulesReqBody>(deleteMymeModuleAPI, {
    args: [
      getMymeIdRecord(mymeId),
      {
        key: 'moduleId',
        value: moduleId
      }
    ]
  });

/* **** PATCH **** /myme/:mymeId */
export const editMyme = async (mymeId: UUID, reqBody: PATCHEditMymeReqBody) =>
  sendRequest<PATCHEditMymeResponse, PATCHEditMymeReqBody>(editMymeAPI, {
    reqBody,
    args: [getMymeIdRecord(mymeId)]
  });

/* **** PATCH **** /myme/:mymeId/modules */
export const editMymeModules = async (mymeId: UUID, reqBody: PATCHEditMymeModulesReqBody) =>
  sendRequest<PATCHEditMymeModulesResponse, PATCHEditMymeModulesReqBody>(editMymeModulesAPI, {
    reqBody,
    args: [getMymeIdRecord(mymeId)]
  });

/* **** GET **** /myme/:mymeId */
export const getSingleMyme = async (mymeId: UUID) =>
  sendRequest<GETSingleMyme, null>(getSingleMymeAPI, {
    args: [getMymeIdRecord(mymeId)]
  });

/* **** GET **** /myme/categories */
export const getTenantMymeCategories = async () =>
  sendRequest<GETTenantMymeCategories, null>(getTenantMymeCategoriesAPI);
